import { useTypedRuntimeConfig } from '~/utils/runtimeConfig'

// The standard gtag snippet, without replacing a gtag or dataLayer already on the page.
// GTM (@nuxt/scripts) uses the default 'dataLayer' and keeps an existing array.
const GTAG_CONSENT_STUB = 'window.dataLayer = window.dataLayer || []; window.gtag = window.gtag || function () { window.dataLayer.push(arguments) }'

// Osano consent and Google Tag Manager, both from runtime config so each
// environment gets its own: the deployment sets NUXT_PUBLIC_GTM_ID (Dev, QA and
// Prod containers differ) and NUXT_PUBLIC_OSANO_JS_URL.
//
// GTM is started here rather than by the @nuxt/scripts registry: the registry
// writes its build-time id into the generated scripts:init plugin, where it
// beats runtime config, so every environment loaded the Dev container that
// .env.template supplies at build. The registry entry in nuxt.config.ts keeps
// no trigger, so this is the first useScriptGoogleTagManager call; every later
// call (stores, components) shares this instance by its registry key.
//
// enforce 'pre' keeps this ahead of any plugin that creates a store calling
// useScriptGoogleTagManager() during setup. AB#64478
//
// Osano sends Google Consent Mode through window.gtag, and skips it silently when
// gtag is undefined. A GTM tag that injected Osano used to supply it; @nuxt/scripts
// defines gtag only when GTM's composable runs during hydration, after Osano has
// run. So a gtag stub on the same dataLayer goes in the head just ahead of Osano.
// AB#65212
export default defineNuxtPlugin({
  name: 'third-party-tags',
  enforce: 'pre',
  setup () {
    const { GTM_ID, OSANO_JS_URL } = useTypedRuntimeConfig().public

    // Synchronous and first in the head, as in nuxt2 (head.script, hid
    // 'osano'): it blocks tags until the visitor has consented. The gtag stub
    // shares Osano's weight (a synchronous script, 'critical'), so unhead orders
    // the two by their place in this entry: the stub renders first.
    if (OSANO_JS_URL) {
      useHead({
        script: [
          { key: 'gtag-consent-stub', innerHTML: GTAG_CONSENT_STUB, tagPriority: 'critical' },
          { key: 'osano', src: OSANO_JS_URL, tagPriority: 'critical' }
        ]
      })
    }

    if (GTM_ID) {
      // Warm the connection, not the script: GTM still starts at onNuxtReady,
      // without an SSR preload competing with the app's critical downloads.
      useScriptGoogleTagManager({ id: GTM_ID, scriptOptions: { trigger: 'onNuxtReady', bundle: false, warmupStrategy: 'preconnect' } })
    }
  }
})
